import { LogicLogicReadModelType } from '@r/api/generated/client.schemas.ts';

export enum LogicTypes {
  STEPS = 'steps',
  TARGETS = 'targets'
}

export type LogicType = LogicTypes.STEPS | LogicTypes.TARGETS;

export type TargetLogicType =
  | typeof LogicLogicReadModelType.TARGET_POINT
  | typeof LogicLogicReadModelType.TARGET_PERF;

export const LOGIC_IRIS = {
  STEP: '/logics/1',
  TARGET_PERF: '/logics/2',
  LINEAR: '/logics/3',
  TARGET_POINT: '/logics/4'
} as const;

export type LogicIri = (typeof LOGIC_IRIS)[keyof typeof LOGIC_IRIS];

export const LOGIC_TYPE_TO_IRI: Record<LogicLogicReadModelType, LogicIri> = {
  [LogicLogicReadModelType.STEP]: LOGIC_IRIS.STEP,
  [LogicLogicReadModelType.LINEAR]: LOGIC_IRIS.LINEAR,
  [LogicLogicReadModelType.TARGET_PERF]: LOGIC_IRIS.TARGET_PERF,
  [LogicLogicReadModelType.TARGET_POINT]: LOGIC_IRIS.TARGET_POINT
};

export const ALL_LOGIC_IRIS = Object.values(LOGIC_IRIS) as [LogicIri, ...LogicIri[]];

export const LOGIC_TRANSLATION_KEYS = {
  [LogicLogicReadModelType.STEP]: 'logic.name.steps',
  [LogicLogicReadModelType.LINEAR]: 'logic.name.linear',
  [LogicLogicReadModelType.TARGET_PERF]: 'logic.name.target.perf',
  [LogicLogicReadModelType.TARGET_POINT]: 'logic.name.target.point'
} as const;

export const isStepLogic = (iri: LogicIri): boolean => iri === LOGIC_IRIS.STEP;
export const isTargetLogic = (iri: LogicIri): boolean =>
  iri === LOGIC_IRIS.TARGET_PERF || iri === LOGIC_IRIS.TARGET_POINT;

/** Logiques pour lesquelles le renouvellement de programme est proposé */
export const RENEWABLE_LOGIC_TYPES = [
  LogicLogicReadModelType.STEP,
  LogicLogicReadModelType.LINEAR,
  LogicLogicReadModelType.TARGET_PERF,
  LogicLogicReadModelType.TARGET_POINT
] as const;

/** Vrai si le type de logique ouvre le flux de renouvellement (dont STEP). */
export const isRenewableLogicType = (
  type: string | undefined
): type is (typeof RENEWABLE_LOGIC_TYPES)[number] =>
  type != null && RENEWABLE_LOGIC_TYPES.includes(type as (typeof RENEWABLE_LOGIC_TYPES)[number]);

/** Vrai pour les workspaces « logique à palier » (admin paliers, boutique reward limitée, etc.). */
export const isStepLogicType = (
  type: string | undefined
): type is typeof LogicLogicReadModelType.STEP => type === LogicLogicReadModelType.STEP;
